/*
Item: Container Components for collecting Cards in Drag'n'Drop in Statistics.jsx, used for Rows only
Name: Container
Format: Code/Frontend component
*/

import React, { Component } from 'react';
// import update from 'immutability-helper'
import { DropTarget } from 'react-dnd';
import Card from './StructureCard';
// import uniqueId from 'lodash/uniqueId';

class HeadingsContainer extends Component {
  constructor(props) {
    super(props);
    // this.state = { cards: props.list };
    this.pushCard = this.props.pushCard;
    this.removeCard = this.props.removeCard;
    this.showOverlay = this.props.showOverlay;
    this.moveCard = this.props.moveCard;
    this.makeNestedList = this.props.makeNestedList;
  }

  render() {
    const cards = this.props.list;
    const {
      canDrop, isOver, connectDropTarget, header,
    } = this.props;
    const isActive = canDrop && isOver;
    const isDuplicate = !canDrop && isOver;
    /*
    const style = {
      width: "200px",
      height: "404px",
      border: '1px dashed gray'
    };
    */

    const backgroundColor = isActive ? 'lightgreen' : isDuplicate ? '#FFB3B3' : '#FFF';
    const { popup } = this.props;

    return connectDropTarget(
      <div title={popup} className="card" style={{ backgroundColor }}>
        <span style={{ color: '#999', fontSize: '12px' }}>{header}</span>
        {cards.map((card, i) => (
          <Card
            key={card.id}
            activeFilter={card.activeFilter}
            activeRule={card.activeRule}
            showRules={card.showRules}
            index={i}
            listId={this.props.id}
            containerName={this.props.containerName}
            card={card}
            removeCard={this.removeCard}
            moveCard={this.moveCard}
            showOverlay={this.showOverlay}
          />
        ))}
      </div>,
    );
  }
}

const cardTarget = {
  drop(props, monitor, component) {
    const { id } = props;
    const { containerName } = props;
    const sourceObj = monitor.getItem();
    if (id !== sourceObj.listId) {
      component.pushCard(sourceObj.card, containerName);
    } else {
      const { makeNestedList } = props;
      const { list } = props;
      makeNestedList(containerName, list);
    }
    return {
      listId: id,
    };
  },
  canDrop(props, monitor) {
    const { list, id, unmoveable } = props;
    const dragItem = monitor.getItem();
    if (unmoveable) { // the container can never be dropped (key figures)
      return false;
    }
    if (id === dragItem.listId) { 
      // does the item originate from the same container?
      return true;
    }
    if (list.some((item) => item.code === dragItem.card.code)) {
      // on external source, does the item already exist inside the container?
      return false;
    }
    if (dragItem.card.type === 'VALUE') {
      // is the dragged item a 'Merkmal'?
      return false;
    }
    return true;
  },
};

export default DropTarget('CARD', cardTarget, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver(),
  canDrop: monitor.canDrop(),
}))(HeadingsContainer);
